import { Region } from "./Types/regionTypes";

export const regionValues: Region = {
	name: "",
	description: "",
	countryId: 0,
	id: 0,
	countryName: "",
};
